import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase/firebaseConfig";

export const trackFirebaseEvent = (
  eventName: string,
  data?: Record<string, any>
) => {
  try {
    if (typeof window === "undefined" || !analytics) return;
    logEvent(analytics, eventName, data || {});
  } catch (error) {
    console.error("Firebase Analytics error:", error);
  }
};
